import { Avatar, SxProps, useTheme } from '@mui/material';
import React from 'react';

interface ProfilePictureProps {
    profileDetails: {
        firstName: string;
        lastName: string;
        email: string;
    };
    src?: string;
    sx?: SxProps;
}

const ProfilePicture = ({ profileDetails, src, sx }: ProfilePictureProps) => {
    const { firstName, lastName, email } = profileDetails || ({} as any);

    const getInitials = () => {
        const hasFirstName =
            typeof firstName === 'string' && firstName.trim().length > 0;
        const hasLastName =
            typeof lastName === 'string' && lastName.trim().length > 0;

        if (hasFirstName && hasLastName) {
            return `${firstName.trim().charAt(0)}${lastName
                .trim()
                .charAt(0)}`.toUpperCase();
        }

        const emailStr = typeof email === 'string' ? email : '';
        const localPart = (emailStr.split('@')[0] || emailStr).trim();
        const dotParts = localPart.split('.').filter(Boolean);

        if (dotParts.length >= 2) {
            return `${dotParts[0].charAt(0)}${dotParts[1].charAt(
                0,
            )}`.toUpperCase();
        }

        return localPart.slice(0, 2).toUpperCase();
    };

    return (
        <Avatar
            alt='profile picture'
            src={src}
            sx={{
                color: 'primary.dark',
                backgroundColor: `custom.profileAvatar`,
                width: '125px',
                height: '125px',
                ...sx,
            }}
        >
            {getInitials()}
        </Avatar>
    );
};

export default ProfilePicture;
